import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "../Food/Foodimage/alaram.mp3";

const MobileCashorders = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [orders, setOrders] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [vendorId, setVendorId] = useState(null);
    const scrollContainerRef = useRef(null);
    const notificationSound = new Audio(sound);

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    useEffect(() => {
        if (!vendorId) return;

        let previousOrderIds = [];

        const fetchOrders = async () => {
            try {
                const token = localStorage.getItem("authToken"); // ✅ Get token
                if (!token) {
                    console.error("Authorization token is missing");
                    return;
                }

                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`, // ✅ Include token in headers
                        },
                    }
                );

                const pendingCashOrders = response.data.filter(
                    (order) =>
                        order.cashStatus === "PENDING" && order.paymentMethod === "Cash"
                );

                const newOrderIds = pendingCashOrders.map((o) => o.orderId);
                const isNewOrder = newOrderIds.some((id) => !previousOrderIds.includes(id));

                // if (isNewOrder) {
                //   notificationSound.play().catch((e) =>
                //     console.warn("Autoplay prevented:", e)
                //   );
                // }

                previousOrderIds = newOrderIds;
                setOrders(pendingCashOrders);
            } catch (error) {
                // console.error("Error fetching orders:", error);
            }
        };

        fetchOrders();
        const intervalId = setInterval(fetchOrders, 1000);

        return () => clearInterval(intervalId);
    }, [vendorId]);


    // Horizontal Auto-scroll
    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval = setInterval(() => {
            if (!isHovered) {
                scrollContainer.scrollLeft += 1;
                if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
                    scrollContainer.scrollLeft = 0;
                }
            }
        }, 20);

        return () => clearInterval(interval);
    }, [isHovered]);

    // Function to determine card color
    const getOrderColor = (orderType) => {
        const normalized = (orderType || "").trim().toLowerCase();
        switch (normalized) {
            case "dine_in":
            case "table_dine_in":
                return "#1E90FF"; // Blue
            case "takeaway":
                return "#FF6347"; // Tomato Red
            case "delivery":
                return "#20B2AA"; // Light Sea Green
            default:
                return "#ccc"; // Grey for unknown
        }
    };


    const handleOrderClick = (order) => {
        if (expandedOrder && expandedOrder.orderId === order.orderId) {
            setExpandedOrder(null);
        } else {
            setExpandedOrder(order);
        }
    };

    const handleCheckboxChange = (orderId, itemIndex) => {
        const key = `${orderId}-${itemIndex}`;
        setCheckedItems((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleAcceptOrder = async (e, orderId) => {
        e.stopPropagation();
        try {
            // ✅ Static values
            const status = "PENDING";       // enum path variable
            const cashStatus = "ACCEPT";    // query param

            // ✅ Get token from localStorage
            const authToken = localStorage.getItem("authToken");

            if (!authToken) {
                console.error("❌ No auth token found in localStorage");
                return;
            }

            // ✅ Build URL correctly
            const url = `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/${status}?cashStatus=${cashStatus}`;

            // ✅ Call API with token
            const response = await axios.put(url, null, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`, // ✅ include token
                },
            });

            // console.log(`✅ Order updated:`, response.data);

            // ✅ Remove updated order from state
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
        } catch (error) {
            console.error(`❌ Failed to update order:`, error.response?.data || error.message);
        }
    };







    const handleDeclineOrder = async (e, orderId) => {
        e.stopPropagation();
        try {
            // ✅ Static values
            const status = "PENDING";       // enum path variable
            const cashStatus = "DECLINE";    // query param

            // ✅ Get token from localStorage
            const authToken = localStorage.getItem("authToken");

            if (!authToken) {
                console.error("❌ No auth token found in localStorage");
                return;
            }

            // ✅ Build URL correctly
            const url = `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/${status}?cashStatus=${cashStatus}`;

            // ✅ Call API with token
            const response = await axios.put(url, null, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`, // ✅ include token
                },
            });

            // console.log(`✅ Order updated:`, response.data);

            // ✅ Remove updated order from state
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
        } catch (error) {
            console.error(`❌ Failed to update order:`, error.response?.data || error.message);
        }
    };



    return (
        <div>
            {/* Internal CSS */}
            <style>
                {`
                @media (min-width: 768px) {
                .order-card{
                display:none !important;
                }
               
                }

             
        @media (max-width: 968px) {
        
          .mobile-orders-wrapper {
            width: 100%;
            left: 0;
            right: 0;
        
            top: 0px;
            height: auto;
      
            padding: 10px;
            border-radius: 0;
          }

          .mobile-scroll-container {
            display: flex;
            flex-direction: row;
            overflow-x: auto;
            gap: 10px;
            padding-bottom: 10px;
            scroll-behavior: smooth;
            margin-top: 50px;
             -ms-overflow-style: none;     /* Internet Explorer and Edge */
  scrollbar-width: none;  
            
          }

          .order-card {
            flex-shrink: 0;
            // width: 250px;
            min-width: 250px;
          }
        }

        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        `}
            </style>

            <div
                className="mobile-orders-wrapper"
                style={{
                    position: "fixed",

                    right: "16px",
                    borderRadius: "8px",
                    padding: "10px",
                    marginTop: "40px",
                }}
            >
                <div
                    className="hide-scrollbar"
                    style={{
                        maxHeight: "600px",
                        overflowY: "auto",
                        paddingRight: "5px",
                        // marginTop: "30px",
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <div className="mobile-scroll-container" ref={scrollContainerRef}>
                        {orders.map((order, index) => (
                            <div
                                key={`${order.orderId}-${index}`}
                                onClick={() => handleOrderClick(order)}
                                className="card order-card"
                                style={{
                                    cursor: "pointer",
                                    marginBottom: "10px",
                                    background: getOrderColor(order.orderService || order.orderType), // ✅ use orderType if orderService is missing
                                    borderRadius: "8px",
                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                    padding: "10px",
                                    position: "relative",
                                    transition: "all 0.3s ease",
                                    height: expandedOrder?.orderId === order.orderId ? "auto" : "120px",
                                }}
                            >
                                {/* Inside your .order-card div, add this after the order ID div */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "10px",
                                        right: "10px",
                                        color: "rgba(255, 255, 255, 0.9)",
                                        fontSize: "18px",
                                        transition: "transform 0.3s ease",
                                        transform: expandedOrder?.orderId === order.orderId ? "rotate(180deg)" : "rotate(0deg)"
                                    }}
                                >
                                    ▼
                                </div>
                                <div style={{ color: "#fff", fontWeight: "bold" }}>
                                    Order ID: #{order.orderId}
                                </div>
                                <div style={{ color: "#fff" }}>
                                    {order.orderService || "N/A"}
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginTop: "10px",
                                    }}
                                >
                                    <button
                                        onClick={(e) => handleAcceptOrder(e, order.orderId)}
                                        style={{
                                            padding: "8px",
                                            backgroundColor: "rgb(177 93 198)",
                                            color: "white",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Accept
                                    </button>
                                    <button
                                        onClick={(e) => handleDeclineOrder(e, order.orderId)}
                                        style={{
                                            padding: "8px",
                                            backgroundColor: "rgb(177 93 198)",
                                            color: "white",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Decline
                                    </button>
                                </div>
                                {expandedOrder?.orderId === order.orderId && (
                                    <div style={{ marginTop: "10px" }}>
                                        <h6 style={{ color: "#fff", fontSize: "18px" }}>Items:</h6>
                                        <ul
                                            style={{
                                                listStyle: "none",
                                                padding: 0,
                                                marginLeft: "10px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {(order.items || order.order || []).map((item, idx) => (
                                                <li
                                                    key={idx}
                                                    style={{
                                                        color: "#000",
                                                        fontSize: "16px",
                                                        marginBottom: "4px",
                                                    }}
                                                >
                                                    <label
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={!!checkedItems[`${order.orderId}-${idx}`]}
                                                            onClick={(e) => e.stopPropagation()}
                                                            onChange={() =>
                                                                handleCheckboxChange(order.orderId, idx)
                                                            }
                                                        />
                                                        {item.dishName} × {item.quantity}
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>


                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileCashorders;
